import { graphql } from 'gatsby'
import React from 'react'
import get from 'lodash/get'
import Seo from 'components/seo'




import Meta from 'components/Meta'
import Layout from 'components/Layout'
import Splash from 'components/Splash'

const BlogIndex = ({ data, location }) => {


  return (
    <Layout location={location}>
      <Seo title='Kedi ve Köpek Mamaları'
      description ='Bütçelerini sarsmadan kedi ve köpeklerini
      sağlıklı bir şekilde büyütmek ve yaşatmak isteyen evcil hayvan aşıkları için özenle hazırlanmış yaş ve kuru mamalar'
      />

      <Splash/>

    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql `
  query IndexQuery {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
        twitter
        adsense
      }
    }


  }
`
